// extracted by mini-css-extract-plugin
export default {"root":"Radio_root__HswWr","radioInput":"Radio_radioInput__1h8fA","label":"Radio_label__taE7s","disabled":"Radio_disabled__90Ez0"};